<!--日期选择控件，用的mint-ui的，startDate需要设置完整的年月日，如果只设置年月，在ios下会有兼容性问题-->
<template>
  <div class="date-picker-con" @touchmove.prevent>
    <div class="cur-date" @click="open">
      {{ curDate ? curDate : '月份筛选' }}
      <span class="arrow"><svg-icon icon-class="arrow"></svg-icon></span>
    </div>
    <mt-datetime-picker
      ref="picker"
      type="date"
      :startDate="new Date('2020/07/01')"
      :endDate="new Date()"
      :yearFormat="'{value}年'"
      :monthFormat="'{value}月'"
      v-model="pickerValue"
      @confirm="confirm">
    </mt-datetime-picker>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        selectDate: new Date(),
        pickerValue: new Date()
      }
    },
    computed: {
      curDate() {
        return `${new Date(this.selectDate).getFullYear()}年${new Date(this.selectDate).getMonth() + 1}月`
      }
    },
    methods: {
      /*打开日期选择器*/
      open() {
        this.$refs.picker.open();
      },
      /*点击确认回调*/
      confirm(val) {
        if (new Date(val).getMonth() === new Date(this.selectDate).getMonth()) {
          if (new Date(val).getFullYear() !== new Date(this.selectDate).getFullYear()) {
           this.ifChangeDate(val)
          }
        } else {
          this.ifChangeDate(val)
        }
      },
      /*判断日期是否改变*/
      ifChangeDate(val) {
        this.selectDate = val
        this.$emit('dateChange', val)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .date-picker-con {
    background-color: #f8f9f9;
    font-size: 28px;

    .cur-date {
      padding: 30px;
      font-size: 28px;
      color: #6D7588;
      padding: 15px 25px;
      background: #fff;
      display: inline-block;
      border-radius: 40px;
      .arrow .svg-icon {
        margin-left: 10px;
        margin-bottom: 4px;
        font-size: 20px;
        transform: rotate(90deg);
      }
    }
  }

  /deep/ .picker-toolbar {
    padding: 30px;
    display: flex;
    justify-content: space-between;



    .mint-datetime-action {
      font-size: 28px;
      width: auto;
    }
  }

  /deep/ .picker-slot {
    font-size: 28px;
  }

  /deep/ .picker-items {
    .picker-slot:nth-child(3) {
      display: none;
    }
  }
</style>
